import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AuthUser {
  accountNo: string
  email: string
  role: string[]
  exp: number
}

interface AuthState {
  isLoggedIn: boolean
  user: AuthUser | null
  setUser: (user: AuthUser | null) => void
  accessToken: string
  setAccessToken: (accessToken: string) => void
  setIsLoggedIn: (isLoggedIn: boolean) => void
  resetAccessToken: () => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isLoggedIn: false,
      user: null,
      accessToken: '',
      setUser: (user) => set({ user }),
      setAccessToken: (accessToken) => set({ accessToken }),
      setIsLoggedIn: (isLoggedIn) => set({ isLoggedIn }),
      resetAccessToken: () => set({ accessToken: '' }),
      logout: () => set({ isLoggedIn: false, user: null, accessToken: '' }),
    }),
    {
      name: 'auth-storage', // unique name for the storage key
    }
  )
)
